// removed by extract-text-webpack-plugin
module.exports = {"container":"cb_cb","full":"cb_ce","page":"cb_cg","xlarge":"cb_ci","large":"cb_g","medium":"cb_ck","small":"cb_cm"};


//////////////////
// WEBPACK FOOTER
// ./elements/container/style.css
// module id = Di9F
// module chunks = 7